import Cookies from 'js-cookie';

export function clearCookies(keepThese = []) {
  Object.keys(Cookies.get()).forEach(function (cookieName) {
    if (!keepThese.includes(cookieName)) Cookies.remove(cookieName);
  });
}
